export const stringHelpers = {
  methods: {
    capitalizeFirstLetter(stringToUpdate) {
      return `${stringToUpdate.charAt(0).toUpperCase()}${stringToUpdate.slice(1)}`;
    },
    nl2br(string) {
      return (string + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br/>$2');
    },
    padStartWithZeroes(toPad, desiredLength) {
      return `${toPad}`.padStart(desiredLength, '0').slice(-desiredLength);
    },
    addNbsp(stringToProcess) {
      if (stringToProcess) {
        const regex =
          /([^A-zÀ-ÖØ-öø-įĴ-őŔ-žǍ-ǰǴ-ǵǸ-țȞ-ȟȤ-ȳɃɆ-ɏḀ-ẞƀ-ƓƗ-ƚƝ-ơƤ-ƥƫ-ưƲ-ƶẠ-ỿ0-9А-я]\S)(\s)/gi;
        return stringToProcess.replace(regex, '$1&nbsp;');
      }
      return null;
    }
  }
};
